import { readMachineStatus } from 'tf-pulse-shared';
import { cn } from '../../utils/className';
import { formatStatusAge } from '../../utils/formatStatusAge';
import { formatStatus } from './machineColumnConfig';

interface MachineHeartbeatNoteProps {
  state: Parameters<typeof readMachineStatus>[0];
  className?: string;
}

/** Qualifies a status that EDMS set because the machine went quiet. */
export function MachineHeartbeatNote({
  state,
  className,
}: MachineHeartbeatNoteProps) {
  const { isSynthetic, lastRecordedStatus, lastRecordedAt } =
    readMachineStatus(state);

  if (!isSynthetic) return null;

  const age = formatStatusAge(lastRecordedAt);

  return (
    <span
      className={cn('size-p2 text-secondary', className)}
      title={
        `EDMS set this because it has not received a heartbeat from ` +
        `this machine recently, so it says nothing about the machine ` +
        `beyond "not heard from".`
      }
    >
      no heartbeat
      {lastRecordedStatus
        ? ` · last reported ${formatStatus(lastRecordedStatus)}${
            age ? ` ${age}` : ''
          }`
        : ''}
    </span>
  );
}
